import React from 'react';
import './Servicios.css';

function Servicios() {
    const servicios = [
        {
            icon: '/images/camion-icono.png',
            titulo: 'Transporte industrial:',
            texto: `Servicio especializado para todo tipo de cargas industriales, incluyendo transportes urgentes y flujos continuos.`,
        },
        {
            icon: '/images/cubo-icono.png',
            titulo: 'Transporte de material para eventos:',
            texto: `Movilización segura y eficiente de equipos y materiales destinados a eventos de cualquier magnitud.`,
        },
        {
            icon: '/images/flechas-icono.png',
            titulo: 'Vehículos especializados:',
            texto: `Disponemos de camiones equipados con plataformas elevadoras, capacidad para cargas laterales y puente grúa, garantizando la máxima flexibilidad y eficiencia en el manejo de mercancías.`,
        },
    ];

    return (
        <section className="servicios-seccion">
            <title>Servicios | DanPauleX</title>
            <link rel="canonical" href="https://danpaulex.com/servicios" />
            <meta
                name="description"
                content="Transporte industrial, transporte de material para eventos y vehículos especializados con plataformas elevadoras, carga lateral y puente grúa."
            />

            <h1 className="visualmente-oculto">Nuestros servicios</h1>
            <div className="servicios-contenedor">
                <div className="servicios-imagen">
                    <img
                        src="/images/servicios-intro.png"
                        alt="En DanPaulex ofrecemos una amplia gama de soluciones logísticas y de transporte, destacándonos en los siguientes servicios:"
                        width="725"
                        height="698"
                        decoding="async"
                    />
                </div>
                <div className="servicios-textos">
                    {servicios.map((s, i) => (
                        <div className="servicio-bloque" key={i}>
                            {/* Icono decorativo: el título ya lo describe */}
                            <img
                                src={s.icon}
                                alt=""
                                className="icono-servicio-png"
                                width="48"
                                height="48"
                                decoding="async"
                            />
                            <div>
                                <h2>{s.titulo}</h2>
                                <p>{s.texto}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Servicios;
